/**
 * Field Registry helpers for Products Row Grouping DataGrid (Config C)
 *
 * Component-specific helpers and grouping constants. The field array itself
 * lives in the domain: client/src/domains/products/flatFields.ts
 */

import { BaseFieldDefinition } from '../shared/types/fieldRegistry';
import { FlatProductRow } from '../fixtures/flatProductData';
import { FLAT_PRODUCT_FIELDS } from '../domains/products/flatFields';
export { FLAT_PRODUCT_FIELDS } from '../domains/products/flatFields';

/**
 * Groupable dimensions - these fields can be used for row grouping
 */
export const GROUPABLE_FIELD_KEYS = [
  'product_cas_name',
  'preferred_product_name',
  'manufacturer_name',
  'facility_name',
  'facility_status',
  'grade_name',
  'therapeutic_area_name',
  'is_ndc_linked',
] as const;

/**
 * Get field definition by key
 */
export function getFieldByKey(
  key: keyof FlatProductRow
): BaseFieldDefinition<FlatProductRow> | undefined {
  return FLAT_PRODUCT_FIELDS.find(field => field.key === key);
}

/**
 * Get all groupable field definitions
 */
export function getGroupableFields(): BaseFieldDefinition<FlatProductRow>[] {
  return FLAT_PRODUCT_FIELDS.filter(field =>
    GROUPABLE_FIELD_KEYS.includes(
      field.key as (typeof GROUPABLE_FIELD_KEYS)[number]
    )
  );
}

/**
 * Get default visible columns (initially all columns shown)
 */
export function getDefaultVisibleColumns(): string[] {
  return FLAT_PRODUCT_FIELDS.map(field => field.key as string);
}
